import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePersonalFeed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomePersonalFeed"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3L3 8.72727V21.139H7.01283C7.19784 18.5461 9.35997 16.5 12 16.5C14.64 16.5 16.8022 18.5461 16.9872 21.139H21V8.72727L12 3ZM12 9.75C10.6193 9.75 9.5 10.8693 9.5 12.25C9.5 13.6307 10.6193 14.75 12 14.75C13.3807 14.75 14.5 13.6307 14.5 12.25C14.5 10.8693 13.3807 9.75 12 9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomePersonalFeed;
